module.exports = __webpack_public_path__ + "img/TestPic.cb2ee80d.png";